jQuery(document).ready(function($) {
    var boxes = $(".expansion-wrapper");
	
	boxes.find(".link").on("click", function(e) {
		e.preventDefault();
		boxes.find(".link").not(this).closest('article').next().removeClass("open");
        $(this).closest('article').next().toggleClass("open");
    });
});
